import React from 'react';
import { Route } from 'react-router';
import ActivityResultsContainer from 'chameleon-src/components/ActivityResultsContainer';

export default (
  <Route
    name="activities"
    path="activities"
    component={ActivityResultsContainer}
  />
);
